import { useCallback, useSyncExternalStore } from "react";
import { PresenceChannelParams } from "@common/types/presence-nats";
import { useUser } from "@hooks/useUser";
import { subscribeToPresence } from "./presenceStore";
import { usePresenceConnection } from "./usePresenceConnection";

const noopUnsubscribe = () => {};

/**
 * Subscribes to a presence channel and reads `getSnapshot` from the presence
 * store on every change. Pass no channel to stay unsubscribed.
 */
export const usePresenceChannelSnapshot = <TSnapshot>(
    channel: PresenceChannelParams | null,
    getSnapshot: () => TSnapshot,
): TSnapshot => {
    const selfUserId = useUser()?.id;
    const connection = usePresenceConnection(channel?.scope);

    const subscribe = useCallback(
        (onChange: () => void) =>
            channel
                ? subscribeToPresence(
                      { channel, connection, selfUserId },
                      onChange,
                  )
                : noopUnsubscribe,
        [channel, connection, selfUserId],
    );

    return useSyncExternalStore(subscribe, getSnapshot);
};
